import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
import * as videoServices from "../../../services/video.services";
import { SWAL_SETTINGS, INPUT_LENGTH_100, INPUT_LENGTH_500, VIDEO_CATEGORY } from "../../../../../utils/Constants";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../../common/customeditor";

const VideoAdd = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useTranslation()
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const [initialValues, setInitialValues] = useState({
        title: "",
        description: "",
        video: "",
        category: "",
    });

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Video"), url: "/admin/cms/video/list/1" },
        { title: t("admin.faq.link_add"), url: "" },
    ];

    // useEffect(() => {
    //     setInitialValues({
    //         title: state && state?.title ? state?.title : "",
    //         description:
    //             state && state?.description ? state?.description : "",
    //         video:
    //             state && state?.video ? state?.video : "",

    //     });
    //     setDataLoaded(true);
    // }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* {dataLoaded ? ( */}
            <Formik
                initialValues={{
                    title: "",
                    description: "",
                    video: "",
                    category: "",
                    thumbnail_image: ""
                }}
                validateOnBlur={false}
                validate={(values) => {
                    const error = {};
                    const MAX_VIDEO_SIZE_MB = 100;
                    const allowedTypes = ["video/mp4", "video/webm", "video/ogg", "video/quicktime"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    if (!values.category) {
                        error.category = "Category is required";
                    }

                    if (!values.video) {
                        error.video = "Please upload a video.";
                    } else {
                        if (!allowedTypes.includes(values.video.type)) {
                            error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                        }
                        const fileSizeMB = values.video.size / (1024 * 1024);
                        if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                            error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                        }
                    }

                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true);
                    globalLoader(true);
                    console.log(values);
                    let formData = new FormData();
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    formData.append("category", values.category);
                    if (values.video) {
                        formData.append("video", values.video);
                    }
                    if (values.thumbnail_image) {
                        formData.append("thumbnail_image", values.thumbnail_image);
                    }
                    videoServices
                        .Add(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    resetForm({ values: "" });
                                    globalLoader(false);
                                    navigate(`/admin/cms/video/list/1`);
                                }, 1000);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                setSubmitted(false);
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Add Video")}</h6>
                                        </div>
                                        <div className="row row-sm">

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="title" className="text-left d-flex">
                                                    {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="title"
                                                    id="title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.title}
                                                    className="form-control"
                                                    placeholder={t("Enter title")}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.title && touched.title && t(errors.title)}
                                                </span>
                                            </div>
                                            <div className="col-md-6 text-center form-group">
                                                <label className="text-left d-flex">
                                                    {t("Category")}
                                                    <span className="requirestar">*</span>
                                                </label>
                                                <select className="form-control form-select cp" name='category' value={values?.category} onChange={handleChange}>
                                                    <option value={""}>{t("Select")}</option>
                                                    {VIDEO_CATEGORY.map((item, index) => { return (<option key={index} value={item.value}>{capitalizeFirstLetter(item.label)}</option>) })}
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.category && touched.category && t(errors.category)}
                                                </span>
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="description" className="text-left d-flex">
                                                    {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                </label>
                                                <CustomCkeditor
                                                    fieldname={"description"}
                                                    setFieldValue={setFieldValue}
                                                    value={values.description}
                                                    setFieldTouched={setFieldTouched}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.description &&
                                                        touched.description &&
                                                        t(errors.description)}
                                                </span>
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="thumbnail_image" className="text-left d-flex">
                                                    Upload Thumbnail Image:
                                                </label>
                                                <input
                                                    className="form-control imgInput"
                                                    id="thumbnail_image"
                                                    name="thumbnail_image"
                                                    accept="image/*"
                                                    type="file"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            "thumbnail_image",
                                                            event.target.files[0] || ""
                                                        );
                                                        event.target.files.length === 1
                                                            ? setPreviewImage(
                                                                URL.createObjectURL(event.target.files[0])
                                                            )
                                                            : setPreviewImage("");
                                                    }}
                                                />
                                                {previewimage ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <img
                                                                src={previewimage}
                                                                style={{ height: "100px" }}
                                                                alt={"Profile_Img"}
                                                            />
                                                            <div className="img_options">
                                                                <button type="button" className="text-danger"
                                                                    onClick={() => {
                                                                        // console.log(previewResImage , previewimage)
                                                                        setPreviewImage("");
                                                                        setFieldValue("thumbnail_image", null);
                                                                        document.getElementById("thumbnail_image").value = ""
                                                                    }}>
                                                                    <i className="ri-delete-bin-6-fill"></i>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="video" className="text-left d-flex">
                                                    {t("Upload Video")}:<span className="requirestar">*</span>
                                                    <Whisper
                                                        placement="top"
                                                        controlId="control-id-hover"
                                                        trigger="hover"
                                                        speaker={
                                                            <Tooltip>
                                                                Maximum video upload size 100MB
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="field-more-info mt-1 ms-1 cp">
                                                            ?
                                                        </span>
                                                    </Whisper>
                                                </label>
                                                <input
                                                    type="file"
                                                    name="video"
                                                    id="video"
                                                    accept="video/*"
                                                    className="form-control"
                                                    onChange={(event) => {
                                                        setFieldValue("video", event.currentTarget.files[0]);
                                                    }}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.video &&
                                                        touched.video &&
                                                        t(errors.video)}
                                                </span>
                                            </div>
                                            <div className="">
                                                <button
                                                    className="btn btn-main-primary signbtn mr-2"
                                                    type="submit"
                                                    disabled={submitted ? true : null}
                                                >
                                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_submit")}
                                                </button>
                                                <button
                                                    className="btn ripple btn-secondary"
                                                    type="button"
                                                    disabled={submitted ? true : null}
                                                    onClick={() => navigate(-1)}
                                                >
                                                    <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_cancel")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            {/* ) : (
                <></>
            )} */}
        </>
    );
};

export default VideoAdd;
